import UsersActivityView from './UsersActivityView';

export default UsersActivityView;
